import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f1633072"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-molid", "data-idx"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FilterInput = _resolveComponent("FilterInput");
    const _component_TitleBar = _resolveComponent("TitleBar");
    const _component_TreeView = _resolveComponent("TreeView", true);
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.allTreeDataFlattened.length > 0 && _ctx.depth === 0)
            ? (_openBlock(), _createBlock(_component_FilterInput, {
                key: 0,
                list: _ctx.allTreeDataFlattened,
                extractTextToFilterFunc: _ctx.extractTextToFilterFunc,
                onOnFilter: _ctx.onFilter,
                mb: "1",
                modelValue: _ctx.filterStr,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.filterStr) = $event))
            }, null, 8, ["list", "extractTextToFilterFunc", "onOnFilter", "modelValue"]))
            : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLocalTreeData, (treeDatum, idx) => {
            return (_openBlock(), _createElementBlock("div", {
                key: treeDatum.id,
                "data-molid": treeDatum.id,
                style: _normalizeStyle(_ctx.styleToUse),
                "data-idx": idx
            }, [
                _createVNode(_component_TitleBar, {
                    treeDatum: treeDatum,
                    depth: _ctx.depth,
                    treeData: _ctx.treeData,
                    filterStr: _ctx.filterStr
                }, null, 8, ["treeDatum", "depth", "treeData", "filterStr"]),
                (treeDatum?.nodes && treeDatum?.treeExpanded)
                    ? (_openBlock(), _createBlock(_component_TreeView, {
                        key: 0,
                        treeData: treeDatum?.nodes,
                        depth: _ctx.depth + 1,
                        styleToUse: _ctx.indentStyle,
                        ref_for: true,
                        ref: treeDatum?.id
                    }, null, 8, ["treeData", "depth", "styleToUse"]))
                    : _createCommentVNode("", true)
            ], 12, _hoisted_1));
        }), 128))
    ]));
}
